import React from 'react';
import PropTypes from 'prop-types';
import Slider from '../forms/slider';
import { simpleFontSize } from '../../utils/settings_builder';

export default function SearchSlider(props) {
  const {
    showSlider,
    minRangePrice,
    setMinPrice,
    maxRangePrice,
    setMaxPrice,
    settings,
  } = props;

  function finishSliding(range) {
    setMinPrice(range.min);
    setMaxPrice(range.max);
  }

  if (showSlider) {
    return (
      <Slider
        style={{
          label: {
            fontSize: settings.fontSize || simpleFontSize,
            color: settings.darkColor,
          },
          container: {
            marginTop: '1em',
          },
          railStyle: {
            backgroundColor: settings.darkColor,
          },
          trackStyle: {
            backgroundColor: settings.borderColor,
          },
          handleStyle: {
            borderColor: settings.darkColor,
          },
        }}
        min={minRangePrice}
        max={maxRangePrice}
        finishSliding={(range) => finishSliding(range)}
      />
    );
  }

  return null;
}

SearchSlider.propTypes = {
  /**
    Boolean value indicating whether or not to show the slider
  */
  showSlider: PropTypes.bool,
  /**
   * The minimum value for the slider. Do not set this dynamically.
   * It is the bottom range value of the slider
   * not the current value where the slider handle is.
   */
  minRangePrice: PropTypes.number,
  /**
   * A callback function called when the lower range is set
  */
  setMinPrice: PropTypes.func.isRequired,
  /**
   * The maximum value for the slider. Do not set this dynamically.
   * It is the bottom range value of the slider
   * not the current value where the slider handle is.
   */
  maxRangePrice: PropTypes.number,
  /**
   * A callback function called when the upper range is set
  */
  setMaxPrice: PropTypes.func.isRequired,
  /**
   * The settings object provided to search
  */
  settings: PropTypes.shape({
    fontSize: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    textColor: PropTypes.string,
    borderColor: PropTypes.string,
    darkColor: PropTypes.string,
    highLightColor: PropTypes.string,
  }).isRequired,
};

SearchSlider.defaultProps = {
  showSlider: false,
  minRangePrice: 0,
  maxRangePrice: 10000,
};
